/**
 * Reveals extra blog article cards (beyond the first 5) when "Load more" is clicked.
 * All articles are already server-rendered; this only toggles visibility client-side.
 */
(() => {
    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-blog-load-more]');
        if (!button) {
            return;
        }
        const grid = document.querySelector('[data-blog-grid]');
        grid?.querySelectorAll('.article-card.is-hidden-extra').forEach((card) => {
            card.classList.remove('is-hidden-extra');
        });
        button.closest('.blog-articles__actions')?.remove();
    });
})();
